export const TEXTS_ENERGIA = {
  es_ES: new Map([
    ['download', 'Descargar'],
    ['energiaEvolucionDiaria', 'ENERGÍA CONSUMIDA Y VERTIDA DIARIA'],
    ['energiaEvolucionAnual', 'ENERGÍA CONSUMIDA Y VERTIDA ANUAL'],
    ['energiaEvolucionMensual', 'ENERGÍA CONSUMIDA Y VERTIDA MENSUAL'],
    ['energiaConsumoMedio', 'CONSUMO MEDIO'],
    ['energiaConsumoMedioDiario', 'DIARIO'],
    ['ultimaActualizacion', 'ultimaActualizacion'],
  ]),
  ca_ES: new Map([
    ['download', 'Descarregar'],
    ['energiaEvolucionDiaria', 'ENERGIA CONSUMIDA I ABOCADA DIÀRIA'],
    ['energiaEvolucionAnual', 'ENERGIA CONSUMIDA I ABOCADA ANUAL'],
    ['energiaEvolucionMensual', 'ENERGIA CONSUMIDA I ABOCADA MENSUAL'],
    ['energiaConsumoMedio', 'CONSUM MITJÀ'],
    ['energiaConsumoMedioDiario', 'DIARI'],
    ['ultimaActualizacion', 'ultimaActualizacion'],
  ]),
};
